import { Add, Delete } from "@mui/icons-material";
import {
    Box, Breadcrumbs,
    Button,
    Checkbox,
    CircularProgress,
    FormControlLabel,
    Grid,
    IconButton, Menu, MenuItem,
    TextField,
    Typography,
} from '@mui/material';
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../api';
import QuotaBlockedNotice from '../../components/subscription/QuotaBlockedNotice';
import CombinedPaymentsEditor from "../../components/checkout/CombinedPaymentsEditor";
import SalesChannelSelect from "../../components/checkout/SalesChannelSelect";
import ShippingMethodsSelect from "../../components/checkout/ShippingMethodsSelect";
import DidNotLoad from "../../components/DidNotLoad";
import MoneyInput from "../../components/MoneyInput";
import MoneyInputWithBlur from "../../components/MoneyInputWithBlur";
import PhoneInput from "../../components/PhoneInput";
import {
    aggregatePaymentDateFromRows,
    buildPaymentMethodsPayload,
    createPaymentRow,
    syncSinglePaymentAmount,
    validatePaymentRows,
} from "../../helpers/checkoutPayments";
import { formatCurrencyInCents, formatPhone } from "../../helpers/formatters";
import { applyName } from "../../helpers/captureMode";
import { externalOrderIdLabel, normalizeExternalOrderUrl } from "../../helpers/salesChannels";
import {
    channelForcesPaid,
    channelNeedsShipping,
    normalizeChannelKind,
    normalizeProductKind,
    productAllowedForChannel,
    productFilterHint,
    productKindLabel,
} from "../../helpers/orderStages";
import { hasPremiumAccess, readStoredPlanName } from "../../helpers/subscription";

function parseShippingCostToCents(shippingCost) {
    if (shippingCost === '' || shippingCost == null) {
        return 0;
    }
    const n = Number(shippingCost);
    if (isNaN(n)) {
        return 0;
    }
    return Math.max(0, Math.round(n * 100));
}

function RegisterCheckoutPage() {
    const [salesChannel, setSalesChannel] = useState('');
    const [selectedChannel, setSelectedChannel] = useState(null);
    const [externalOrderId, setExternalOrderId] = useState('');
    const [externalOrderUrl, setExternalOrderUrl] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [productName, setProductName] = useState('');
    const [productUnitPrice, setProductUnitPrice] = useState('');
    const [productQuantity, setProductQuantity] = useState(1);
    const [productId, setProductId] = useState('');
    const [productKind, setProductKind] = useState('');
    const [payments, setPayments] = useState(() => [createPaymentRow()]);
    const [customerWillPayLater, setCustomerWillPayLater] = useState(false);
    const [shippingMethod, setShippingMethod] = useState('Retirada no local');
    const [shippingCost, setShippingCost] = useState('0');
    const [commission, setCommission] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [discountReason, setDiscountReason] = useState('');
    const [observations, setObservations] = useState('');
    const [shippingDeliveryDays, setShippingDeliveryDays] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [finishOrder, setFinishOrder] = useState(false);
    const [saleOccurredAt, setSaleOccurredAt] = useState(() => new Date());
    const [products, setProducts] = useState([]);
    const [amount, setAmount] = useState(0);
    const navigate = useNavigate();
    const [resultErrors, setResultErrors] = useState({
        has_errors: false,
        customer_name: null,
        sales_channel: null,
        products: null,
        shipping_method: null,
        payment_methods: null,
        discount_reason: null,
        external_order_id: null,
        external_order_url: null,
    });
    const productsTotal = products.reduce((sum, product) => sum + product.total, 0);
    const shippingCents = parseShippingCostToCents(shippingCost);
    const discountCents = Math.max(0, Math.round((Number(discount) || 0) * 100));
    const grossAmount = productsTotal + shippingCents;
    const payableAmount = Math.max(0, productsTotal - discountCents) + shippingCents;
    const [hasResponse, setHasResponse] = useState(false);
    const [didNotLoad, setDidNotLoad] = useState(false);
    const [isLoadingCustomerSearch, setIsLoadingCustomerSearch] = useState(false);
    const [isLoadingProductSearch, setIsLoadingProductSearch] = useState(false);
    const timerRef = useRef(null); // Usado para armazenar o timer
    const [customerResults, setCustomerResults] = useState([]);
    const [productResults, setProductResults] = useState([]);
    const [anchorElCustomer, setAnchorElCustomer] = useState(null);
    const [anchorElProduct, setAnchorElProduct] = useState(null);
    const [addProductErrors, setAddProductErrors] = useState({
        product_name: '',
        product_price: '',
        product_quantity: '',
    });
    const [photo, setPhoto] = useState(null);
    const [photoPreview, setPhotoPreview] = useState(null);
    const hasPremium = hasPremiumAccess(readStoredPlanName());

    const handleCheckboxChange = (event) => {
        setCustomerWillPayLater(event.target.checked);
        if (event.target.checked) {
            setPayments([]);
        } else {
            setPayments([createPaymentRow({ amountCents: payableAmount, paymentDate: saleOccurredAt || new Date() })]);
        }
    };

    useEffect(() => {
        if (customerWillPayLater) {
            return;
        }
        setPayments((prev) => syncSinglePaymentAmount(prev, payableAmount));
    }, [payableAmount, customerWillPayLater]);

    const handleUpdateAmount = () => {
        // Atualiza o total bruto (soma o valor de todos os produtos + valor de entrega)
        const shippingCostInCents = parseShippingCostToCents(shippingCost);
        console.log('shipping', shippingCostInCents)
        console.log('products', products)
        const newAmount = products.reduce((sum, product) => sum + product.total, 0) + shippingCostInCents;
        console.log('amount', newAmount)
        setAmount(newAmount);
    }

    const handleAddProduct = () => {
        const unitPriceInCents = parseFloat(productUnitPrice.replace(/[^\d]/g, ""));
        const shippingCostInCents = parseShippingCostToCents(shippingCost);
        const currentQuantity = parseInt(productQuantity);

        let hasProductErrors = false;
        let currentProductErrors = {
            product_name: '',
            product_price: '',
            product_quantity: '',
        };

        console.log('productId', productId);
        console.log('productName', productName);
        if (productName === '' && productId === '') {
            console.log('travando no product_name');
            currentProductErrors.product_name = 'Informe o nome do produto';
            hasProductErrors = true;
        }

        console.log('unitPriceInCents', unitPriceInCents);
        if (isNaN(unitPriceInCents) || unitPriceInCents <= 0) {
            console.log('travando no product_price');
            currentProductErrors.product_price = 'Informe o valor do produto';
            hasProductErrors = true;
        }

        console.log('currentQuantity', currentQuantity);
        if (isNaN(currentQuantity) || currentQuantity <= 0) {
            console.log('travando no product_quantity');
            currentProductErrors.product_quantity = 'Deve ser informada a quantidade';
            hasProductErrors = true;
        }

        console.log('hasProductErrors', hasProductErrors);
        console.log('addProductErrors', addProductErrors);

        if (hasProductErrors) {
            setResultErrors({
                ...resultErrors,
                has_errors: true,
            });
            setAddProductErrors({
                ...addProductErrors,
                ...currentProductErrors,
            })
            return
        }

        setAddProductErrors({
            product_name: '',
            product_price: '',
            product_quantity: '',
        });
        setResultErrors({
            ...resultErrors,
            has_errors: false,
        });
        hasProductErrors = false;

        let product = {
            name: productName,
            base_price: unitPriceInCents,
            quantity: currentQuantity,
            total: unitPriceInCents * productQuantity,
            kind: normalizeProductKind(productKind),
        };
        if (productId !== '') {
            product.id = productId;
            setProductId('');
        }
        setProductKind('');

        // Adiciona o produto ao array de produtos
        const newProducts = [...products, product];
        setProducts(newProducts);

        const newAmount = newProducts.reduce((sum, product) => sum + product.total, 0) + shippingCostInCents;
        setAmount(newAmount);

        // Limpa os campos de entrada
        setProductName('');
        setProductUnitPrice('');
        setProductQuantity(1);
    };

    const handleRemoveProduct = (index) => {
        const shippingCostInCents = parseShippingCostToCents(shippingCost);
        // Remove o produto pelo índice
        const newProducts = products.filter((_, i) => i !== index);
        setProducts(newProducts);

        // Atualiza o total
        const newAmount = newProducts.reduce((sum, product) => sum + product.total, 0) + shippingCostInCents;
        setAmount(newAmount);
    };

    useEffect(() => {
        if (channelForcesPaid(selectedChannel?.kind)) {
            setCustomerWillPayLater(false);
            if (payments.length === 0) {
                setPayments([createPaymentRow({ amountCents: payableAmount, paymentDate: saleOccurredAt || new Date() })]);
            }
        }
    }, [selectedChannel]);

    const handleSubmit = (event) => {
        event.preventDefault();

        let allRequiredFieldsOk = true;
        let invalidData = {};
        if (products.length === 0) {
            invalidData.products = 'Você deve incluir ao menos 1 produto. Informe o nome, valor unitário, quantidade e clique no botão "Incluir este produto" para adicionar.';
            allRequiredFieldsOk = false;
        }

        if (customerId === '' && customerName === '') {
            invalidData.customer_name = 'Informe o nome do cliente';
            allRequiredFieldsOk = false;
        }
        if (discountCents > 0 && String(discountReason || '').trim() === '') {
            invalidData.discount_reason = 'Informe o motivo do desconto.';
            allRequiredFieldsOk = false;
        }
        if (selectedChannel?.requires_external_order_id === true && String(externalOrderId || '').trim() === '') {
            invalidData.external_order_id = `Informe o ${externalOrderIdLabel(selectedChannel?.name)}.`;
            allRequiredFieldsOk = false;
        }
        const trimmedExternalUrl = String(externalOrderUrl || '').trim();
        if (trimmedExternalUrl && !normalizeExternalOrderUrl(trimmedExternalUrl)) {
            invalidData.external_order_url = 'Informe uma URL válida (http ou https).';
            allRequiredFieldsOk = false;
        }
        if (!customerWillPayLater) {
            const paymentError = validatePaymentRows(payments, payableAmount);
            if (paymentError) {
                invalidData.payment_methods = paymentError;
                allRequiredFieldsOk = false;
            }
        }
        if (!allRequiredFieldsOk) {
            setResultErrors({
                ...resultErrors,
                ...invalidData,
                has_errors: true,
            });
            return
        }

        if (isSubmitting) return; // Evita duplo clique
        setIsSubmitting(true); // Ativa o estado de loading

        let currentShippingDeliveryDays = shippingDeliveryDays
        if (currentShippingDeliveryDays === '') {
            currentShippingDeliveryDays = 0
        }

        const paymentMethods = customerWillPayLater ? [] : buildPaymentMethodsPayload(payments);
        const aggregatePaymentDate = customerWillPayLater
            ? null
            : aggregatePaymentDateFromRows(payments);

        const newCheckout = {
            customer: {
                id: customerId,
                name: customerName,
                phone: customerPhone,
            },
            shipping_method: {
                name: shippingMethod,
                cost: shippingCost * 100,
                delivery_days: parseInt(currentShippingDeliveryDays),
            },
            products: products,
            amount: grossAmount,
            discount: discountCents,
            discount_reason: discountCents > 0 ? String(discountReason || '').trim() : '',
            observations: String(observations || '').trim(),
            external_order_id: String(externalOrderId || '').trim(),
            external_order_url: normalizeExternalOrderUrl(externalOrderUrl) || String(externalOrderUrl || '').trim(),
            sales_channel: {
                id: salesChannel,
            },
            finish_order: true,
            commission: Math.max(0, Math.round((Number(commission) || 0) * 100)),
            payment_details: {
                paid: channelForcesPaid(selectedChannel?.kind) ? true : !customerWillPayLater,
            },
        };
        if (paymentMethods.length > 0) {
            newCheckout.payment_methods = paymentMethods;
        }

        if (!customerWillPayLater && aggregatePaymentDate != null) {
            newCheckout.payment_details.payment_date = aggregatePaymentDate.toISOString();
        }

        if (saleOccurredAt != null) {
            newCheckout.created_at = saleOccurredAt.toISOString();
        }

        let redirectTo = '/admin/orders'

        console.log('Checkout', newCheckout);

        // Prepara os dados para envio
        let requestData = newCheckout;
        let requestConfig = {};

        // Se há uma foto, enviar como FormData
        if (photo) {
            const formData = new FormData();
            formData.append('photo', photo);
            formData.append('checkout_data', JSON.stringify(newCheckout));
            requestData = formData;
            requestConfig = {};
        }

        api.post('checkouts', requestData, requestConfig)
            .then((response) => {
                try {
                    const data = response.data;
                    if (!data?.success) {
                        setResultErrors({
                            ...data.errors,
                            has_errors: true,
                        });
                    } else {
                        console.log('Venda iniciada com sucesso:', response);
                        navigate(redirectTo); // Redireciona de volta para a lista
                    }
                    setHasResponse(true);
                } catch (error) {
                    console.log(error);
                }
            })
            .catch((error) => {
                try {
                    const data = error.response.data;
                    setResultErrors({
                        ...data.errors,
                        has_errors: true,
                    });
                    setHasResponse(true);
                } catch (error) {
                    console.log(error);
                }
            })
            .finally(() => {
                setIsSubmitting(false); // Desativa o estado de loading
                if (!hasResponse) {
                    setDidNotLoad(true);
                }
            });
    };

    const customerSearch = (customerName) => {
        if (customerName.length >= 3) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            timerRef.current = setTimeout(() => {
                setIsLoadingCustomerSearch(true);
                api.get(`customers?q=${customerName}`)
                    .then((response) => {
                        const d = response.data;
                        const rows = Array.isArray(d?.customers)
                            ? d.customers
                            : Array.isArray(d?.data)
                                ? d.data
                                : [];
                        setCustomerResults(rows);

                        setIsLoadingCustomerSearch(false);
                    })
                    .catch((error) => {
                        console.error(error);
                        setCustomerResults([]); // Evita que o menu fique aberto com erro
                        setIsLoadingCustomerSearch(false);
                    });
            }, 1000);
        } else {
            setCustomerResults([]); // Limpa os resultados se o nome for menor que 3 caracteres
        }
    };

    const handleCloseCustomerMenu = () => {
        setAnchorElCustomer(null);
        setCustomerResults([]);
    };

    const productSearch = (productName) => {
        if (productName.length >= 3) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            timerRef.current = setTimeout(() => {
                setIsLoadingProductSearch(true);
                api.get(`products?q=${productName}`)
                    .then((response) => {
                        const d = response.data;
                        const rows = Array.isArray(d?.products)
                            ? d.products
                            : Array.isArray(d?.data)
                                ? d.data
                                : [];
                        const channelKind = normalizeChannelKind(selectedChannel?.kind);
                        setProductResults(rows.filter((product) => productAllowedForChannel(channelKind, product.kind)));

                        setIsLoadingProductSearch(false);
                    })
                    .catch((error) => {
                        console.error(error);
                        setProductResults([]); // Evita que o menu fique aberto com erro
                        setIsLoadingProductSearch(false);
                    });
            }, 1000);
        } else {
            setProductResults([]); // Limpa os resultados se o nome for menor que 3 caracteres
        }
    };

    const handleCloseProductMenu = () => {
        setAnchorElProduct(null);
        setProductResults([]);
    };

    const handlePhotoChange = (file, preview) => {
        setPhoto(file);
        setPhotoPreview(preview);
    };

    if (didNotLoad) {
        return <DidNotLoad />
    }

    return (
        <div>
            <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" onClick={() => navigate('/admin')} to={'/admin'}>
                    Dashboard
                </Link>
                <Link color="inherit" onClick={() => navigate('/admin/orders')} to={'/admin/orders'}>
                    Pedidos
                </Link>
                <Typography color="text.primary">Novo pedido</Typography>
            </Breadcrumbs>
            <br />
            <Typography variant="h4" gutterBottom>Novo pedido</Typography>
            <QuotaBlockedNotice quotaKey="checkouts" backTo="/admin/orders" />
            {hasPremium && (
                <Box sx={{ mb: 2 }}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        startIcon={<Add />}
                        onClick={() => navigate('/admin/orders/batch')}
                    >
                        Pedidos em lote
                    </Button>
                </Box>
            )}
            <form onSubmit={handleSubmit}>
                <Grid item xs={12} sm={12}>Canal de vendas</Grid>
                <Box mb={2} />
                <SalesChannelSelect
                    label="Por onde a venda está sendo feita"
                    value={salesChannel}
                    onChange={(e) => setSalesChannel(e.target.value)}
                    onChannelChange={setSelectedChannel}
                />
                {resultErrors.sales_channel && (
                    <div
                        className="text-danger mt-1"
                        style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                    >
                        {resultErrors.sales_channel}
                    </div>
                )}
                {selectedChannel?.requires_external_order_id === true && (
                    <>
                        <Box mb={2} />
                        <TextField
                            label={externalOrderIdLabel(selectedChannel?.name)}
                            fullWidth
                            value={externalOrderId}
                            onChange={(e) => setExternalOrderId(e.target.value)}
                        />
                        {resultErrors.external_order_id && (
                            <div
                                className="text-danger mt-1"
                                style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                            >
                                {resultErrors.external_order_id}
                            </div>
                        )}
                        <Box mb={2} />
                        <TextField
                            label="URL do pedido no painel (opcional)"
                            fullWidth
                            value={externalOrderUrl}
                            onChange={(e) => setExternalOrderUrl(e.target.value)}
                            placeholder="https://seller.shopee.com.br/portal/sale/order/…"
                            helperText="Cole o link dos detalhes do pedido no painel do canal, se quiser abrir depois pela lista."
                        />
                        {resultErrors.external_order_url && (
                            <div
                                className="text-danger mt-1"
                                style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                            >
                                {resultErrors.external_order_url}
                            </div>
                        )}
                    </>
                )}
                <Box mb={2} />
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                    <DateTimePicker
                        label="Data e hora da venda"
                        value={saleOccurredAt}
                        onChange={(newValue) => setSaleOccurredAt(newValue)}
                        slotProps={{ textField: { fullWidth: true } }}
                    />
                </LocalizationProvider>
                <Box mb={6} />
                <Grid item xs={12} sm={12}>
                    <Typography variant="h5">Dados do cliente</Typography>
                </Grid>
                <Box mb={2} />
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="customer-name"
                            label={isLoadingCustomerSearch ? 'Buscando cliente...' : 'Nome (obrigatório)'}
                            fullWidth
                            value={customerName}
                            onChange={(e) => {
                                setCustomerName(e.target.value);
                                customerSearch(e.target.value);
                            }}
                            onFocus={(e) => setAnchorElCustomer(e.currentTarget)} // Aqui está a correção!
                        />
                        <Menu
                            anchorEl={anchorElCustomer}
                            open={Boolean(anchorElCustomer) && customerResults.length > 0}
                            onClose={handleCloseCustomerMenu} // Fecha o menu ao clicar fora
                            disableAutoFocusItem
                        >
                            {customerResults.map((customer) => (
                                <MenuItem
                                    key={customer.uuid || customer.id}
                                    onClick={() => {
                                        setCustomerName(customer.name);
                                        setCustomerEmail(customer.email || '');
                                        setCustomerPhone(formatPhone(customer.phone));
                                        setCustomerId(customer.uuid || customer.id || '');
                                        handleCloseCustomerMenu();
                                    }}
                                >
                                    {applyName(customer.name)}
                                </MenuItem>
                            ))}
                        </Menu>
                        {resultErrors.customer_name && (
                            <div
                                className="text-danger mt-1"
                                style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                            >
                                {resultErrors.customer_name}
                            </div>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <PhoneInput
                            label="Telefone"
                            value={customerPhone}
                            onChange={(e) => setCustomerPhone(e.target.value)}
                            disabled={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="E-mail"
                            fullWidth
                            value={customerEmail}
                            onChange={(e) => setCustomerEmail(e.target.value)}
                            type="email"
                        />
                        {resultErrors.customer_email && (
                            <div
                                className="text-danger mt-1"
                                style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                            >
                                {resultErrors.customer_email}
                            </div>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Typography variant="h5">Produtos</Typography>
                        {productFilterHint(selectedChannel?.kind) ? (
                            <Typography variant="body2" color="text.secondary">{productFilterHint(selectedChannel?.kind)}</Typography>
                        ) : null}
                    </Grid>
                    <Box mb={2} />
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label={isLoadingProductSearch ? 'Buscando produto...' : 'Nome do produto (obrigatório)'}
                            fullWidth
                            value={productName}
                            onChange={(e) => {
                                setProductName(e.target.value);
                                productSearch(e.target.value);
                            }}
                            onFocus={(e) => setAnchorElProduct(e.currentTarget)} // Aqui está a correção!
                        />
                        <Menu
                            anchorEl={anchorElProduct}
                            open={Boolean(anchorElProduct) && productResults.length > 0}
                            onClose={handleCloseProductMenu} // Fecha o menu ao clicar fora
                            disableAutoFocusItem
                        >
                            {productResults.map((product) => (
                                <MenuItem
                                    key={product.uuid || product.id}
                                    onClick={() => {
                                        setProductName(product.name);
                                        setProductUnitPrice((product.base_price / 100));
                                        setProductQuantity(1);
                                        setProductId(product.uuid || product.id);
                                        setProductKind(normalizeProductKind(product.kind));
                                        handleCloseProductMenu();
                                    }}
                                >
                                    {product.name} — {formatCurrencyInCents(product.base_price)} ({productKindLabel(product.kind)})
                                </MenuItem>
                            ))}
                        </Menu>
                        {addProductErrors.product_name && (
                            <div
                                className="text-danger mt-1"
                                style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                            >
                                {addProductErrors.product_name}
                            </div>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <MoneyInput
                            label="Valor unitário"
                            value={productUnitPrice}
                            onChange={(newValue) => setProductUnitPrice(newValue)} // Passa apenas o valor numérico bruto
                        />
                        {addProductErrors.product_price && (
                            <div
                                className="text-danger mt-1"
                                style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                            >
                                {addProductErrors.product_price}
                            </div>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="Quantidade"
                            fullWidth
                            value={productQuantity}
                            onChange={(e) => setProductQuantity(e.target.value)}
                            inputMode="numeric"
                        />
                        {addProductErrors.product_quantity && (
                            <div
                                className="text-danger mt-1"
                                style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                            >
                                {addProductErrors.product_quantity}
                            </div>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleAddProduct}
                            startIcon={<Add />}
                            fullWidth // Adicionando fullWidth para responsividade
                        >
                            Incluir este produto
                        </Button>
                    </Grid>

                    <Grid item xs={12} sm={12}>Produtos Adicionados</Grid>
                    <Box mb={2} />
                    <Grid item xs={12} sm={12}>
                        <ul>
                            {products.map((product, index) => (
                                <li key={index}>
                                    {product.name} - {product.quantity} x {formatCurrencyInCents(product.base_price)} = {formatCurrencyInCents(product.total)}
                                    <IconButton onClick={() => handleRemoveProduct(index)}>
                                        <Delete color="error" />
                                    </IconButton>
                                </li>
                            ))}
                        </ul>
                        {resultErrors.products && (
                            <div
                                className="text-danger mt-1"
                                style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                            >
                                {resultErrors.products}
                            </div>
                        )}
                    </Grid>

                    <Grid item xs={12} sm={12}><hr /></Grid>
                    <Grid item xs={12} sm={12}>
                        <Typography variant="h5">Desconto e comissão</Typography>
                    </Grid>
                    <Box mb={2} />
                    <Grid item xs={12} sm={4}>
                        <MoneyInputWithBlur
                            label="Desconto"
                            value={discount}
                            onChange={(values) => setDiscount(values.value === '' ? 0 : values.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Motivo do desconto"
                            fullWidth
                            value={discountReason}
                            onChange={(e) => setDiscountReason(e.target.value)}
                            helperText={discountCents > 0 ? 'Obrigatório quando há desconto' : ' '}
                        />
                        {resultErrors.discount_reason && (
                            <div
                                className="text-danger mt-1"
                                style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                            >
                                {resultErrors.discount_reason}
                            </div>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MoneyInputWithBlur
                            label="Comissão (opcional)"
                            value={commission}
                            onChange={(values) => setCommission(values.value === '' ? 0 : values.value)}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12}><hr /></Grid>
                    <Grid item xs={12} sm={12}>
                        <Typography variant="h5">Dados de pagamento</Typography>
                    </Grid>
                    <Box mb={2} />

                    {!channelForcesPaid(selectedChannel?.kind) ? (
                    <Grid item xs={12} sm={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={customerWillPayLater}
                                    onChange={handleCheckboxChange}
                                    color="primary"
                                />
                            }
                            label="O pagamento desta venda será realizado em outro momento"
                        />
                    </Grid>
                    ) : (
                    <Grid item xs={12}>
                        <Typography variant="body2" color="text.secondary">
                            Pagamento já realizado na plataforma. O repasse aparece como &quot;a liberar&quot; até a liberação.
                        </Typography>
                    </Grid>
                    )}
                    {!customerWillPayLater && (
                        <Grid item xs={12}>
                            <CombinedPaymentsEditor
                                payments={payments}
                                onChange={setPayments}
                                totalAmountCents={payableAmount}
                                defaultDate={saleOccurredAt || new Date()}
                            />
                        </Grid>
                    )}

                    {resultErrors.payment_methods && (
                        <Grid item xs={12} sm={12}>
                            <div
                                className="text-danger mt-1"
                                style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                            >
                                {resultErrors.payment_methods}
                            </div>
                        </Grid>
                    )}

                    {channelNeedsShipping(selectedChannel?.kind) ? (
                        <>
                    <Grid item xs={12} sm={12}><hr /></Grid>
                    <Grid item xs={12} sm={12}>
                        <Typography variant="h5">Dados de entrega</Typography>
                    </Grid>
                    <Box mb={2} />
                    <Grid item xs={12} sm={4}>
                        <ShippingMethodsSelect
                            label="Forma de entrega"
                            value={shippingMethod}
                            onChange={(e) => setShippingMethod(e.target.value)}
                        />
                        {resultErrors.shipping_method && (
                            <div
                                className="text-danger mt-1"
                                style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                            >
                                {resultErrors.shipping_method}
                            </div>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MoneyInputWithBlur
                            label="Informe o valor do frete"
                            value={shippingCost}
                            onChange={(values) => setShippingCost(values.value)}
                            onBlur={handleUpdateAmount}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Prazo em dias"
                            fullWidth
                            value={shippingDeliveryDays}
                            onChange={(e) => setShippingDeliveryDays(e.target.value)}
                            inputMode="numeric"
                        />
                    </Grid>
                        </>
                    ) : null}
                    <Grid item xs={12} sm={12}><hr /></Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            label="Observações"
                            fullWidth
                            multiline
                            minRows={3}
                            value={observations}
                            onChange={(e) => setObservations(e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12}><hr /></Grid>
                    <Grid item xs={12} sm={12}>
                        <Typography variant="h3" align="center">Total: {formatCurrencyInCents(payableAmount)}</Typography>
                        {discountCents > 0 && (
                            <Typography variant="body2" align="center" color="text.secondary">
                                Bruto: {formatCurrencyInCents(grossAmount)} · Desconto: {formatCurrencyInCents(discountCents)}
                            </Typography>
                        )}
                    </Grid>
                </Grid>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' }, // Empilha no mobile, lado a lado em telas maiores
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: 2,
                        marginBottom: 8,
                        gap: 2 // Espaçamento entre os itens
                    }}
                >
                    {/* Mensagem de erro à esquerda */}
                    {resultErrors.has_errors ? (
                        <div
                            className="text-danger"
                            style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}
                        >
                            Ocorreram erros de validação, verifique os campos acima.
                        </div>
                    ) : (
                        <div style={{ height: '1rem' }} />
                    )}

                    {/* Botões responsivos */}
                    <Grid container spacing={2} sx={{ width: { xs: '100%', sm: 'auto' } }}>
                        <Grid item xs={12} sm="auto">
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                disabled={isSubmitting}
                                startIcon={isSubmitting && <CircularProgress size={20} color="inherit" />}
                                fullWidth
                            >
                                {isSubmitting ? 'Registrando...' : 'Registrar pedido'}
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </form>
        </div>
    );
}

export default RegisterCheckoutPage;
